import styled from 'styled-components';
import { ifProp, palette, theme } from 'styled-tools';
import { units } from '../../utils/spacing';
import { fontSize, FontSizes } from '../../utils/typography';
export const ListItem = styled.div `
	display: flex;
	align-items: center;
	margin-bottom: ${ifProp('$noItemMargin', '', units(2))};
	min-height: ${theme('buttons.minHeight')};
`;
export const ListItemText = styled.p `
	margin: ${units(0, 1, 0, 2)};
	${ifProp('$condensed', fontSize(FontSizes.sm))};
`;
export const IconWrapper = styled.div `
	backdrop-filter: blur(${units(0.75)});
	padding: ${ifProp('$condensed', units(0.5), units(1))};
	border-radius: 50%;
	display: flex;
	justify-content: center;
	align-items: center;

	svg {
		height: ${units(3)};
		width: ${units(3)};

		path {
			fill: ${palette('white')};
			height: ${units(3)};
			width: ${units(3)};
		}
	}

	background: ${props => {
    var _a;
    return props.$iconBackgroundColor
        ? palette(props.$iconBackgroundColor)
        : `rgba(0, 0, 0, ${(_a = props.$iconBackgroundAlpha) !== null && _a !== void 0 ? _a : '0.3'})`;
}};

	border: 2px solid ${props => palette(props.$iconBorderColor)};
`;
//# sourceMappingURL=styles.js.map